import { Injectable } from '@angular/core';
import { DetailsWokingDayAPIService } from './details-woking-day-api.service';
import { EventService } from 'src/app/Service/event.service';
import { Observable } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DetailsWokingDayService {

  constructor(protected eventService: EventService,
    private readonly branchCaeApiService: DetailsWokingDayAPIService) { }

  public async getReport(filter: string, page = 0, size = 10): Promise<any> {
    try {
      this.eventService.startLoadingData();
      const response: any = await this.branchCaeApiService.getReportFile(filter, page, size);
      if (response.code == 'SUCCESS') {
        const data = response.content || null;
        return data;
      } else {
        return null;
      }
    } catch (error: any) {
      console.error('Error in getReport:', error);
      // Optionally, you can notify the user or handle the error in another way
      return null;
    } finally {
      this.eventService.completeLoadingData();
    }
  }


  public async getDataGrid(filter: string, page = 0, size = 10): Promise<any> {
    try {
      this.eventService.startLoadingData();
      const response: any = await this.branchCaeApiService.getDataGrid(filter, page, size);
      if (response.code == 'SUCCESS') {
        const data = response.content || null;
        return data;
      } else {
        return null;
      }
    } catch (error: any) {
      console.error('Error in getDataGrid:', error);
      // Optionally, you can notify the user or handle the error in another way
      return null;
    } finally {
      this.eventService.completeLoadingData();
    }
  }

}
